(function () {

  "use strict";

  angular.module("PrintixProviderNetwork", [])

    .constant("RequiredNetworkModelProperties", [
      "_embedded"
    ])

    .constant("NetworkEmbeddedPropertiesAdmin", "")

    .constant("NetworkEmbeddedProperties", "")

    .factory("NetworkModel", ["$rootScope", "Utils", "$filter", "RequiredNetworkModelProperties", "$http", "$q",
      "PrintixNetworkInfoConstants", "NetworkEmbeddedPropertiesAdmin", "NetworkEmbeddedProperties", "$injector",
      function($rootScope, Utils, $filter, RequiredNetworkModelProperties, $http, $q, PrintixNetworkInfoConstants,
        NetworkEmbeddedPropertiesAdmin, NetworkEmbeddedProperties, $injector) {
        return function(networkDataReceived) {
          //START VARIABLES**************************************************************************************/
          var NetworkModel = {},
            NetworkModelPrivate = {},
            networkUrlSuffix = "";
          try {
            $injector.get("APIAdmin");
            networkUrlSuffix = NetworkEmbeddedPropertiesAdmin;
          } catch (e) {
            networkUrlSuffix = NetworkEmbeddedProperties;
          }
          //END VARIABLES****************************************************************************************/


          //START init*******************************************************************************************/
          NetworkModel.init = function(networkDataReceived) {
            if (Utils.objectPropertiesCheck(networkDataReceived, RequiredNetworkModelProperties)) {
              NetworkModel.info = angular.copy(networkDataReceived);
              NetworkModel.options = {
                isSelected: false,
                isDefaultNetwork: false
              };
              NetworkModel.customProperties = {};
              NetworkModelPrivate.normalizeLinks();
            } else {
              throw "NetworkModel: networkDataReceived is not valid";
            }
          };
          //END init*********************************************************************************************/


          //START NetworkModel***********************************************************************************/
          NetworkModelPrivate.normalizeLinks = function() {
            angular.forEach(NetworkModel.info._links, function(link, index) {
              if (angular.isObject(link) && !angular.isArray(link)) {
                var linkClean = link.href.split("?")[0];
                NetworkModel.info._links[index].href = linkClean;
              }
            });
            var selfHrefSplit = NetworkModel.info._links.self.href.split("/");
            NetworkModel.customProperties.id = selfHrefSplit[selfHrefSplit.length - 1];
          };

          NetworkModel.replaceInfo = function(embeddedKey, data, doNotReplaceEmbeddedAndLinks) {
            if (!NetworkModel.info._embedded) {
              NetworkModel.info._embedded = {};
            }
            if (embeddedKey) {
              NetworkModel.info._embedded[embeddedKey] = angular.copy(data);
            } else {
              var embedded = angular.copy(NetworkModel.info._embedded);
              var links = angular.copy(NetworkModel.info._links);
              NetworkModel.info = angular.copy(data);
              if (!doNotReplaceEmbeddedAndLinks) {
                NetworkModel.info._embedded = embedded;
                NetworkModel.info._links = links;
              }
              NetworkModelPrivate.normalizeLinks();
            }
          };

          NetworkModel.showInfo = function() {
            $rootScope.$emit(PrintixNetworkInfoConstants.SHOW, NetworkModel);
          };

          NetworkModel.discoverNetwork = function(network, snmpConfig) {
            var deferred = $q.defer()
            var objectToSend = {
              snmpConfiguration: snmpConfig.info._links.self.href
            }

            $http.post(network.info._links["px:discoverEnvironment"].href, objectToSend).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error)
            });
            return deferred.promise;
          };

          NetworkModel.refreshNetworkInfo = function() {
            var deferred = $q.defer();
            $http.get(NetworkModel.info._links.self.href + networkUrlSuffix).then(function(response) {
              NetworkModel.replaceInfo(null, response.data);
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          };

          NetworkModel.addGateway = function(gateway, updateOtherNetworks) {
            if (gateway) {
              var url = NetworkModel.info._links.self.href;
              if (updateOtherNetworks) {
                url += "?updateOthers=true";
              }
              var deferred = $q.defer();
              $http.patch(url, gateway, {
                headers: {
                  "Content-Type": "application/json"
                }
              }).then(
                function(response) {
                  NetworkModel.replaceInfo(null, response.data);
                  deferred.resolve(response);
                }).catch(function(error) {
                  deferred.reject(error);
                });
              return deferred.promise;
            } else {
              throw "NetworkModel.addGateway: adapter is missing";
            }
          };

          NetworkModel.removeGateway = function(gateway) {
            if (gateway) {
              var deferred = $q.defer();
              $http.patch(NetworkModel.info._links.self.href + "?delete=true", gateway, {
                headers: {
                  "Content-Type": "application/json"
                }
              }).then(
                function(response) {
                  NetworkModel.replaceInfo(null, response.data);
                  deferred.resolve(response);
                }).catch(function(error) {
                  deferred.reject(error);
                });
              return deferred.promise;
            } else {
              throw "NetworkModel.removeGateway: gateway is missing";
            }
          };

          // NetworkModel.makeDefault = function() {
          //   alert("NOT IMPLEMENTED YET")
          // };
          //END NetworkModel*************************************************************************************/


          //START SaveChanges************************************************************************************/
          NetworkModel.saveChanges = function(networkChanged) {
            if (networkChanged) {
              var patchObjectArray = Utils.getObjectsDifferencesForPatching(NetworkModel.info, networkChanged.info);
              if (patchObjectArray && patchObjectArray.length > 0) {
                patchObjectArray = NetworkModelPrivate.resetToGlobalSetting(patchObjectArray, networkChanged);
                var deferred = $q.defer();
                $http.patch(NetworkModel.info._links.self.href, patchObjectArray).then(function(response) {
                  NetworkModel.replaceInfo(null, response.data);
                  deferred.resolve(response);
                }).catch(function(error) {
                  deferred.reject(error);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw "NetworkModel.saveChanges: networkChanged is missing";
            }
          };

          NetworkModelPrivate.resetToGlobalSetting = function(patchObjectArray, networkChanged) {
            for (var i = 0; i < patchObjectArray.length; i++) {
              if (patchObjectArray[i].path === '/clientMigratePrintQueues' && networkChanged.info.clientMigratePrintQueues === null) {
                patchObjectArray[i].op = 'remove';
              }
            }
            return patchObjectArray;
          }
          //END SaveChanges**************************************************************************************/


          //START CREATE*****************************************************************************************/
          NetworkModel.init(networkDataReceived);
          delete NetworkModel.init;
          //END CREATE*******************************************************************************************/

          return NetworkModel;
        };
      }
    ])

    .factory('UnknownNetworkListPaging', ['DEFAULT_ITEMS_PER_PAGE',
      function(DEFAULT_ITEMS_PER_PAGE){
        return function () {

          var UnknownNetworkListPaging = {
            pagingCriteria: {
              page: 0,
              pageSize: DEFAULT_ITEMS_PER_PAGE,
              direction: 'DESC',
              match: null,
              sort: 'WS_COUNT'
            }
          }

          UnknownNetworkListPaging.getPagedUrlParameters = function () {
            var urlParameters =
              '?page=' + UnknownNetworkListPaging.pagingCriteria.page +
              '&pageSize=' + UnknownNetworkListPaging.pagingCriteria.pageSize +
              '&direction=' + UnknownNetworkListPaging.pagingCriteria.direction +
              '&sort=' + UnknownNetworkListPaging.pagingCriteria.sort;

              if (UnknownNetworkListPaging.pagingCriteria.match) {
                urlParameters += '&match=' + UnknownNetworkListPaging.pagingCriteria.match
              }

              return urlParameters;
          }

          return UnknownNetworkListPaging;

        }
      }
    ])

    .factory('NetworkListPOSTPaging', ['DEFAULT_ITEMS_PER_PAGE', function(DEFAULT_ITEMS_PER_PAGE){
      return function () {
        var NetworkListPOSTPaging = {};
        NetworkListPOSTPaging.pagingCriteria = {
          page: 0,
            pageSize: DEFAULT_ITEMS_PER_PAGE,
            direction: 'ASC',
            match: null,
            sort: 'NAME',
            airPrint: null,
            hasSite: null,
            sites: null,
            networkTypeFilter: null,
            excludeNetworkIds: null,
            networkIds: null,
        }

        return NetworkListPOSTPaging;
      }
    }])

    .factory("NetworkListPaging", ["DEFAULT_ITEMS_PER_PAGE",
      function(DEFAULT_ITEMS_PER_PAGE) {
        return function(workstationDataReceived) {
          //START VARIABLES**************************************************************************************/
          var NetworkListPaging = {};
            NetworkListPaging.pagingCriteria = {
            page: 0,
            pageSize: DEFAULT_ITEMS_PER_PAGE,
            direction: "ASC",
            match: null,
            sort: 'NAME',
            airPrint: null,
            hasSite: null,
            sites: null,
            networkTypeFilter: null,
            networkIds: null,
          };
          //END VARIABLES****************************************************************************************/

          //START PrinterListPaging*******************************************************************************/
          NetworkListPaging.getPagedUrlParameters = function() {
            var urlParameters =
              '?page=' + this.pagingCriteria.page +
              "&pageSize=" + this.pagingCriteria.pageSize +
              "&direction=" + this.pagingCriteria.direction;

            if (this.pagingCriteria.sort) {
              urlParameters += "&sort=" + this.pagingCriteria.sort;
            }
            if (this.pagingCriteria.networkIds) {
              urlParameters += "&networkIds=" + this.pagingCriteria.networkIds;
            }
            if (this.pagingCriteria.airPrint || this.pagingCriteria.airPrint === false) {
              urlParameters += "&airPrint=" + this.pagingCriteria.airPrint;
            }
            if (this.pagingCriteria.match) {
              urlParameters += "&match=" + this.pagingCriteria.match;
            }
            if (this.pagingCriteria.excludeNetworkIds) {
              urlParameters += "&excludeNetworkIds=" + this.pagingCriteria.excludeNetworkIds;
            }

            if (this.pagingCriteria.hasSite === false || NetworkListPaging.pagingCriteria.hasSite === true) {
              urlParameters += "&hasSite=" + this.pagingCriteria.hasSite;
            }

            if (this.pagingCriteria.sites) {
              for (var i = 0; i < this.pagingCriteria.sites.length; i++) {
                urlParameters += "&sites=" + this.pagingCriteria.sites[i];
              }
            }

            // THIS IS A PIECE OF HAGGIS made to force OFFICE as default filter and NONE if both OFFICE & HOME filters is set
            if (!this.pagingCriteria.networkTypeFilter || this.pagingCriteria.networkTypeFilter === 'OFFICE') {
              urlParameters += "&networkTypeFilter=OFFICE";
            } else {
              if (this.pagingCriteria.networkTypeFilter === 'HOME') {
                urlParameters += "&networkTypeFilter=" + this.pagingCriteria.networkTypeFilter;
              } else {
                urlParameters += "&networkTypeFilter=NONE";
              }
            }

            return urlParameters;
          }
          //END PrinterListPaging*******************************************************************************/
          return NetworkListPaging;
        };
      }
    ])

    .service("NetworkListService", ["$rootScope", "NetworkModel", "$filter", "Utils", "TenantListService", "$http", "$q",
      "USER_RIGHTS", "EventServiceEvents", "NetworkEmbeddedPropertiesAdmin", "NetworkEmbeddedProperties",
      function($rootScope, NetworkModel, $filter, Utils, TenantListService, $http, $q, USER_RIGHTS, EventServiceEvents,
        NetworkEmbeddedPropertiesAdmin, NetworkEmbeddedProperties) {
        //START VARIABLES******************************************************************************************/
        var NetworkListModelPrivate = {},
          networkListServiceAsObject = this,
          getNetworksListUrlSuffix = "";
        this.list = [];
        try {
          $injector.get("APIAdmin");
          getNetworksListUrlSuffix = NetworkEmbeddedPropertiesAdmin;
        } catch (e) {
          getNetworksListUrlSuffix = NetworkEmbeddedProperties;
        }
        //END VARIABLES********************************************************************************************/

        //START NetworkListService*********************************************************************************/
        NetworkListModelPrivate.getNetwork = function (url) {
          if (url) {
            var deferred = $q.defer();
            $http.get(url).then(function(response) {
              var networkFound = networkListServiceAsObject.list.findElement({
                info: {
                  _links: {
                    self: {
                      href: url
                    }
                  }
                }
              });
              if (!networkFound) {
                networkListServiceAsObject.list.add(new NetworkModel(response.data));
              } else {
                networkListServiceAsObject.list[networkListServiceAsObject.list.indexOf(networkFound)] = new NetworkModel(response.data);
              }
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw "NetworkListModelPrivate.getNetwork: url is missing";
          }
        };

        this.getNetworkById = function (networkId) {
          if (networkId) {
            var deferred = $q.defer();
            var watch = $rootScope.$watch(function() {
              return TenantListService.currentTenant;
            }, function() {
              if (TenantListService.currentTenant &&
                TenantListService.currentTenant.info._links["px:networks"].href) {
                $http.get(TenantListService.currentTenant.info._links["px:networks"].href + "/" + networkId + getNetworksListUrlSuffix).then(function(response) {
                  if (response && response.data) {
                    var network = new NetworkModel(response.data);
                    var networkFound = networkListServiceAsObject.list.findElement({
                      info: {
                        _links: {
                          self: {
                            href: network.info._links.self.href
                          }
                        }
                      }
                    });
                    if (networkFound) {
                      networkFound.replaceInfo(null, network.info, true);
                      watch();
                      deferred.resolve(networkFound);
                    } else {
                      networkListServiceAsObject.list.add(network);
                      watch();
                      deferred.resolve(network);
                    }
                  } else {
                    watch();
                    deferred.reject(response);
                  }
                }).catch(function(error) {
                  watch();
                  deferred.reject(error);
                });
              }
            });
            return deferred.promise;
          } else {
            throw "NetworkListModel.getNetworkById: networkId is missing";
          }
        };

        this.getNetworksByIds = function (networkIds) {
          const deferred = $q.defer();

          const url = TenantListService.currentTenant.info._links['px:networks'].href + '/byIds';
          $http.post(url, networkIds).then(function (response) {
            deferred.resolve(response);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        this.getNetworkByUrl = function (url) {
          if (url) {
            var deferred = $q.defer();
            $http.get(url).then(function(response) {
              deferred.resolve(response.data);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'getNetworkByUrl: no working URL provided for this action'
          }
        };

        this.getNetworkModelByUrl = function (url) {
          if (url) {
            var deferred = $q.defer();
            $http.get(url).then(function(response) {
              var network = new NetworkModel(response.data);
              deferred.resolve(network);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'getNetworkByUrl: no working URL provided for this action'
          }
        };

        this.deleteNetwork = function (network, isEvent, destinationNetwork) {

          var url = network.info._links.self.href
          if (destinationNetwork) {
            url = url + '?movePrintersToNetwork=' + destinationNetwork.info._links.self.href;
          }

          if (isEvent) {
            networkListServiceAsObject.list.remove(network);
          } else {
            var deferred = $q.defer();
            $http.delete(url).then(function() {
              networkListServiceAsObject.list.remove(network);
              deferred.resolve();
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }
        };

        this.deleteSelectedNetworks = function (networksList, callback) {
          if (networksList.length > 0) {
            angular.forEach(networksList, function(network) {
              networkListServiceAsObject.deleteNetwork(network);
            });
            if (callback) {
              callback();
            }
          } else {
            throw "NetworkListService.deleteSelectedNetworks: no network was found using the provided search criteria";
          }
        };

        this.addNewNetwork = function (networkName) {
          if (networkName) {
            var deferred = $q.defer();
            $http.post(TenantListService.currentTenant.info._links["px:networks"].href, {
              name: networkName
            }).then(function(response) {
              if (!networkListServiceAsObject.list.contains({
                  info: {
                    _links: {
                      self: {
                        href: response.data._links.self.href
                      }
                    }
                  }
                })) {
                networkListServiceAsObject.list.add(new NetworkModel(response.data));
              }
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw "NetworkListService.addNewNetwork: networkName is missing";
          }
        };

        this.addNetworkWithAdapters = function (networkName, adapters) {
          var newNetwork = {
            name: networkName,
            gateways: adapters
          }

          var deferred = $q.defer();
          $http.post(TenantListService.currentTenant.info._links['px:networks'].href, newNetwork).then(function(response){
            deferred.resolve(response);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        this.getNetworkListPaged = function (networkListPaging) {
          if (TenantListService.currentTenant && TenantListService.currentTenant.info._links["px:networks"].href) {
            return this.getNetworkListPagedByPost(networkListPaging); 
          }
        };

        this.getNetworkListPagedByPost = function (networkListPaging, embed) {

          if (typeof networkListPaging.pagingCriteria.networkTypeFilter === 'string') {
            networkListPaging.pagingCriteria.networkTypeFilter = networkListPaging.pagingCriteria.networkTypeFilter.split(',').map((item) => {
              return item.trim();
            });
          }
          
          if ($rootScope.currentUser.siteFilter.applySiteFilter) {
            networkListPaging.pagingCriteria.sites = $rootScope.currentUser.siteFilter.sites;
          }
          var deferred = $q.defer()
          var postObject = networkListPaging.pagingCriteria;
          var params = '?page=' + networkListPaging.pagingCriteria.page + '&pageSize=' + networkListPaging.pagingCriteria.pageSize + '&direction=ASC&sort=NAME';
          var url = TenantListService.currentTenant.info._links['px:networkSearch'].href + params;
          if (embed) {
            url = url + embed;
          }

          $http.post(url, postObject).then(function(response) {
           var networkListObject = {
             page: response.data.page,
             _links: response.data._links,
             list: []
           }
           if (response.data && response.data._embedded && response.data._embedded['px:networkResources']) {
             angular.forEach(response.data._embedded['px:networkResources'], function(networkData){
              networkListObject.list.add(new NetworkModel(networkData));
             });
           }
           deferred.resolve(networkListObject);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        if (!$rootScope.currentUser) {
          var listener = $rootScope.$watch(function() {
            return $rootScope.currentUser;
          }, function() {
            if ($rootScope.currentUser) {
              listener();
              // networkListServiceAsObject.getNetworkList();
            }
          }, false);
        }
        //END NetworkListService***********************************************************************************/

        //START EVENT LISTENERS*************************************************************************************/
        var watch = $rootScope.$watch(function() {
          return $rootScope.currentUser;
        }, function() {
          if ($rootScope.currentUser && $rootScope.currentUser.info &&
            $filter("contains")($rootScope.currentUser.info._embedded.permissions.permissions, USER_RIGHTS.ADMIN_LOGIN)) {

            watch();

            $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.NETWORK_ADDED, function(name, data) {
              NetworkListModelPrivate.getNetwork(data.network);
            });

            $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.NETWORK_REMOVED, function(name, data) {
              var networkFound = networkListServiceAsObject.list.findElement({
                info: {
                  _links: {
                    self: {
                      href: data.network
                    }
                  }
                }
              });
              if (networkFound) {
                networkListServiceAsObject.deleteNetwork(networkFound, true);
              }
            });

            $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.NETWORK_CHANGED, function(name, data) {
              var networkFound = networkListServiceAsObject.list.findElement({
                info: {
                  _links: {
                    self: {
                      href: data.network
                    }
                  }
                }
              });
              if (networkFound) {
                networkFound.refreshNetworkInfo();
              }
            });
          }
        });
        //END EVENT LISTENERS***************************************************************************************/
      }
    ]);
})();
